import classNames from 'classnames'
import { useEffect } from 'react'

type ToastProps = {
  text: string
  onClose?: () => void
  position?: string
}

const Toast = ({ text, onClose, position = 'bottom' }: ToastProps) => {
  useEffect(() => {
    if (!onClose) return
    const timer = setTimeout(onClose, 2000)
    return () => clearTimeout(timer)
  }, [])

  function positionHandler() {
    if (position === 'top') {
      return 'bottom-auto top-[88px]'
    }
    if (position === 'belowTopBanner') {
      return 'bottom-auto top-[152px]'
    }
    return 'bottom-8 top-auto'
  }

  return (
    <div
      className={classNames(
        `caption-1 pointer-events-none fixed left-[50%] z-199 translate-x-[-50%] whitespace-nowrap rounded-md bg-dim-090 px-[18px] py-2 text-center text-white ${positionHandler()}`
      )}
      dangerouslySetInnerHTML={{ __html: text }}
    ></div>
  )
}

export default Toast
